import { useDispatch, useSelector } from 'react-redux';
import { useForm, Controller } from "react-hook-form";
import { useTranslation } from 'react-i18next';

import { classNames } from 'primereact/utils';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';

import { useCreateGroupMutation } from '../../../../queries';
import { toggleDialog } from '../../../../redux/Slices/Global/globalSlice';

// Exact icon path from .claude/pp-dialogs-prototype.html's "مجموعة جديدة" form dialog.
const IcNewGroup = () => (
    <svg viewBox="0 0 24 24">
        <rect x="3" y="4" width="7" height="7" rx="1.5" /><rect x="14" y="4" width="7" height="7" rx="1.5" />
        <rect x="3" y="15" width="7" height="7" rx="1.5" /><path d="M17.5 15v6M14.5 18h6" />
    </svg>
);
const IcClose = () => <svg width="18" height="18" viewBox="0 0 24 24" style={{ stroke: 'currentColor', fill: 'none', strokeWidth: 2 }}><path d="M6 6l12 12M18 6L6 18" /></svg>;

const CreateGroup = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { openDialog } = useSelector((state) => state.global);
    const { control, formState: { errors }, handleSubmit } = useForm();
    const createGroup = useCreateGroupMutation()

    const onSubmit = async (data) => {
        await createGroup.mutateAsync({ "name": data.name })
    };

    const getFormErrorMessage = (name) => {
        return errors[name] && <small className="p-error">{errors[name].message}</small>
    };

    const closePopup = () => {
        dispatch(toggleDialog("createGroupDialog"))
    }
    return (

        <Dialog visible={openDialog.createGroupDialog}
            breakpoints={{ '960px': '95vw' }}
            style={{ width: '420px' }}
            showHeader={false}
            modal className="pp-dlg" onHide={closePopup}>

            <div className="pp-dlg-hd">
                <span className="ic"><IcNewGroup /></span>
                <div>
                    <div className="t">{t('devices.group_create_group')}</div>
                    <div className="s">{t('devices.group_create_group_subtitle')}</div>
                </div>
                <span className="x" onClick={closePopup}><IcClose /></span>
            </div>

            <form onSubmit={handleSubmit(onSubmit)}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        e.preventDefault();
                        handleSubmit(onSubmit)();
                    }
                }}>
                <div className="pp-dlg-bd">
                    <div className="pp-dlg-fld">
                        <label>{t('form.name')}</label>
                        <Controller name="name" control={control}
                            rules={{ required: t('devices.group_name_required') }}
                            render={({ field, fieldState }) => (
                                <InputText id={field.name} {...field} autoFocus
                                    className={classNames({ 'p-invalid': fieldState.invalid })} />
                            )} />
                        {getFormErrorMessage('name')}
                    </div>
                </div>

                <div className="pp-dlg-ft">
                    <button type="submit" className="btn primary" disabled={createGroup.isLoading}>{t('buttons.create')}</button>
                    <button type="button" className="btn ghost" disabled={createGroup.isLoading} onClick={closePopup}>{t('buttons.cancel')}</button>
                </div>
            </form>
        </Dialog>
    );
};
export default CreateGroup;
